import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HowItWorks from '../components/HowItWorks';
import Stats from '../components/Stats';
import Brokers from '../components/Brokers';
import CTA from '../components/CTA';

export default function HowItWorksPage() {
  return (
    <div className="min-h-screen bg-[#0a0a0b] flex flex-col">
      <Navbar />
      <main className="flex-1">
        <HowItWorks />
        <Stats />
        <Brokers />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
